import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Planning');

export const CADASTRALSECTION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CadastralSection.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.CadastralSection.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const CADASTRALSECTION_CONFIG = {
  entityName: 'CadastralSection',
  localizationKey: 'Planning::Entity.CadastralSection',
  permission: 'PlanningGeography.CadastralSections',
  fields: CADASTRALSECTION_FIELDS,

  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
